import styles from "./Scans.module.scss";

import { GreetingsHeader } from '../../components/common/GreetingsHeader';
import { CardItem } from '../../components/CardItem';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/common/Button';
import { useQuery } from '@apollo/client';
import { ASSESSMENTS_ROUTES } from '../../apollo/queries';
import { useContext, useState } from 'react';
import { AssessmentRoute } from '../../apollo/types/AssessmentRoute';
import { RequestAssessment } from '../../components/RequestAssessment';
import { UserContext } from '../../context/UserContext';
import { Features } from '../../apollo/types/features';
import Loader from "../../components/common/Loader";

const scanImage = (name: string) => {
    switch(name) {
        case 'DiscoveryScan':
            return '/assets/scan_logos/DiscoveryScan.jpeg';
        case 'ConsistencyScan':
            return '/assets/scan_logos/ConsistencyScan.jpeg';
        case 'ProgressScan':
            return '/assets/scan_logos/UpdateScan.jpeg';
    }
}

export const Scans = () => {
    const [isActive, setActive] = useState(true)
    const [assessmentRoutes, setAssessmentRoutes] = useState<[AssessmentRoute] | []>([]);
    const [sendInvite, setSendInvite] = useState(false);
    const [selectedAssessmentRoute, setSelectedAssessmentRoute] = useState<number | null>(null);
    const navigate = useNavigate();

    const userContext = useContext(UserContext)
    const isSuperAdmin = userContext?.organisation?.id === 1;
    let updateScanEnabled = false;
    if(userContext.organisation?.features?.length) {
        for (const feature of userContext.organisation.features) {
            if(feature.name === Features.PROGRESS_SCAN && feature.status === 'ENABLED') {
                updateScanEnabled = true;
            }
        }
    }

    useQuery(ASSESSMENTS_ROUTES, {
        onCompleted: (someData) => {
            setAssessmentRoutes(someData.myAssessmentRoutes)
            setActive(value => !value)
        },
        fetchPolicy: "no-cache"
    });

    return (
        <div className={styles.wrapper}>
            <GreetingsHeader title="Choose an analysis" subtitle=''/>
            <Loader active={isActive}>
                <section className={styles.cardWrapper}>
                    {assessmentRoutes?.map(({ id, name, url, description}) => (
                        <CardItem
                            key={id}
                            id={id}
                            name={name}
                            img={scanImage(name) ?? ''}
                            text={description}
                            // onDelete={deletePrograms}
                            element={
                                <>
                                <Button className="simple" onClick={() => {
                                    setSelectedAssessmentRoute(id);
                                    setSendInvite(true)
                                }}>Request scan</Button>
                                {/*{ isSuperAdmin &&*/}
                                    <Button className="simple" onClick={() => {
                                        window.open(`/assessments/${url}`,'_blank');
                                    }}>Start scan</Button>
                                {/*}*/}
                                </>
                            }
                        />
                    ))}
                    {updateScanEnabled &&
                        <CardItem
                            key={-1}
                            id={-1}
                            name={'Progress Scan'}
                            img={scanImage('ProgressScan') ?? ''}
                            text={'Request a progress scan'}
                            // onDelete={deletePrograms}
                            element={
                                <Button className="simple" onClick={() => {
                                    navigate('/library/request-progress-scan')
                                }}>Request progress scan</Button>
                            }
                        />
                    }
                </section>
                <RequestAssessment
                    routes={assessmentRoutes}
                    button={false}
                    isOpen={sendInvite}
                    onOpenChange={(isOpen: boolean) => {
                        setSendInvite(isOpen)
                    }}
                    preSelectedAssessmentRoute={selectedAssessmentRoute}
                />
            </Loader>
        </div>
    )
};
